










































































import { Vue, Component } from 'vue-property-decorator';
import { Button, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import SlideVerify from '@/components/SlideVerify.vue';
import { getBaseInfo, submit } from '../api';

Vue.use(Button)
  .use(Toast)
  .use(Popup);

@Component({
  components: {
    SlideVerify,
  },
})
export default class Home extends Vue {
  activeTabIndex = 0;
  baseInfo: any = {};
  name = '';
  phone = '';
  idCardNum = '';
  showPopup = false;
  slideVerified = false;

  async mounted() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/topics/activity/2020-06-11/6OJHyX92-1591871407087.jpg';
    // App分享
    this.$appShareInfo({
      title: '梦回宋朝',
      url: location.href,
      subtitle: '梦回宋朝',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '梦回宋朝',
        subtitle: '梦回宋朝',
        image: cover,
      });
    }
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  checkForm() {
    const mobileReg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
    if (!this.name) {
      Toast('请输入姓名');
      return false;
    } else if (!this.phone || !mobileReg.test(this.phone)) {
      Toast('请填写正确的手机号');
      return false;
    } else if (!this.idCardNum) {
      Toast('请填写身份证号');
      return false;
    } else {
      return true;
    }
  }
  onTabClick(index: number) {
    this.activeTabIndex = index;
  }
  async onSubmit() {
    if (!this.checkForm()) {
      return console.log('form checked failed');
    }
    this.showPopup = true;
  }
  async onSlideVerifyPass(data: any) {
    this.showPopup = false;
    const ret: any = await submit({
      title: this.name,
      phone: this.phone,
      chinaid: this.idCardNum,
    });
    Toast(ret.msg);
    (this.$refs.slideVerify as SlideVerify).reset();
  }
  onBlur() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      window.scrollTo(0, 0);
    }
  }
}
